export default "__VITE_ASSET__5c61931b__"